// Placeholder slice
import { createSlice } from '@reduxjs/toolkit'

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: {},
  reducers: {},
})

export default notificationSlice.reducer
